import DrawerForExamples from "../drawer/DrawerForExamples";
import IllustrativeGrid from "../illustrative-grid/IllustrativeGrid";
import angularPhotoGuide_1 from './../../assets/svg/foto-angolari/front-left.svg'
import angularPhotoGuide_2 from './../../assets/svg/foto-angolari/rear-left.svg'
import angularPhotoGuide_3 from './../../assets/svg/foto-angolari/rear-right.svg'
import angularPhotoGuide_4 from './../../assets/svg/foto-angolari/front-right.svg'
import { tqPageView } from "../../utils/utils";

const exampleItems = [<img src={angularPhotoGuide_1} alt="front-left" key={"front-left"} />, <img src={angularPhotoGuide_2} alt="rear-left" key={"rear-left"} />, <img src={angularPhotoGuide_3} alt="rear-right" key={"rear-right"} />, <img src={angularPhotoGuide_4} alt="front-right" key={"front-right"} />]

const EsempiFotoAngolareVeicolo = () => {

    const examplesGrid = <IllustrativeGrid
        items={exampleItems}
    />

    const onOpenHandler = () => {
        tqPageView('cai:raccolta foto:esempi illustrati veicolo')
    }

    return (
        <>
            <DrawerForExamples
                ctaLabel="Vedi esempi"
                drawerTitleLabel={"Esempi illustrati di foto del veicolo"}
                drawerContent={examplesGrid}
                onOpenCb={onOpenHandler}
            />
        </>
    )
}

export default EsempiFotoAngolareVeicolo